export const safeSignalPeer = (peer, signal, label = "peer") => {
    if (!peer || peer.destroyed) {
        return false;
    }

    try {
        peer.signal(signal);
        return true;
    } catch (error) {
        console.log(`[${label}] Failed to signal peer:`, error?.message || error);
        return false;
    }
};

export const destroyPeer = (peer, label = "peer") => {
    if (!peer || peer.destroyed) {
        return;
    }

    try {
        peer.destroy();
    } catch (error) {
        console.log(`[${label}] Failed to destroy peer:`, error?.message || error);
    }
};

export const destroyPeerCollection = (peerEntries = [], label = "peer-collection") => {
    peerEntries.forEach((entry) => destroyPeer(entry?.peer, label));
    return [];
};

export const stopMediaStream = (mediaStream) => {
    if (!mediaStream) {
        return;
    }

    mediaStream.getTracks().forEach((track) => {
        track.stop();
    });
};

export const bindSocketEvents = (socket, listeners) => {
    listeners.forEach(({ event, handler, once }) => {
        if (once) {
            socket.once(event, handler);
            return;
        }

        socket.on(event, handler);
    });

    return () => {
        listeners.forEach(({ event, handler }) => {
            socket.off(event, handler);
        });
    };
};
